// extracted by mini-css-extract-plugin
export default {"colorList":"wPjcbDtZ","colorButton":"qzZmDU2n","colorButtonCurrent":"uKnbIst8"};